var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdition1Line88(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edition_1-line-88") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.75c0-7.3 5.95-13.25 13.25-13.25s13.25 5.95 13.25 13.25h1c0-7.85-6.4-14.25-14.25-14.25s-14.25 6.4-14.25 14.25 6.4 14.25 14.25 14.25v-1c-7.3 0-13.25-5.95-13.25-13.25zM7.25 14.75c0-4.15 3.35-7.5 7.5-7.5s7.5 3.35 7.5 7.5h1c0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5 3.8 8.5 8.5 8.5v-1c-4.15 0-7.5-3.35-7.5-7.5zM14.75 12.25c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5zM14.75 16.25c-0.85 0-1.5-0.65-1.5-1.5s0.65-1.5 1.5-1.5 1.5 0.65 1.5 1.5-0.65 1.5-1.5 1.5zM31.35 30.65l-11.050-11.050 7.25 0.65 0.1-1-9.25-0.85 0.75 9.3 1-0.1-0.6-7.35 11.1 11.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdition1Line88);
export default __webpack_public_path__ + "static/media/edition_1-line-88.472e929677a3904f8ba020ce8e2e38b0.svg";
export { ForwardRef as ReactComponent };